import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

import { AppServerAPI } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { MobileConnection, MobileConnectionResult } from '@sdbn/tmc-common';

export class TransportRegistrationSmartphoneConnectionController extends AbstractStepController {

  private refreshInterval = 10000;
  private maxRetries = 10;
  private retry = 0;

  private dialogService: DialogService;
  appServerAPI: AppServerAPI;

  nextControl = new StepControl();
  alreadyConnectedControl = new StepControl();

  phoneNumberValid: boolean = false;

  regexNumbers = /^\+?[0-9 ]+$/;

  constructor(
  ) {
    super();

    this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.driverCommunication) {
      this.onDriverCommunicationChange();
      this.updateControls();
    } else if (contextChange.key === TerminalContextConstants.phoneNumber) {
      this.onDriverCommunicationChange();
      this.phoneNumberValid = this.validatePhoneNumber(contextChange.value);
      this.dashboardContext.setContextValue('phoneNumberValid', this.phoneNumberValid);
      this.updateControls();
    }


  }

  onRegisterToDashboardContext() {

    const availableCommunicationOptions = this.wizardComponent.currentStep.dashboardConfiguration?.availableOptions;
    this.dashboardContext.setContextValue('available_communication_options', availableCommunicationOptions);

    const showPhoneNumberInputForGlobalConnect = this.wizardComponent.currentStep.dashboardConfiguration?.showPhoneNumberInputForGlobalConnect;
    this.dashboardContext.setContextValue('showPhoneNumberInputForGlobalConnect', showPhoneNumberInputForGlobalConnect === true);

    const hidePhoneNumberInput = this.wizardComponent.currentStep.dashboardConfiguration?.hidePhoneNumberInput;
    this.dashboardContext.setContextValue('hidePhoneNumberInput', hidePhoneNumberInput === true);

    const showPhoneNumberDialog = this.wizardComponent.currentStep.dashboardConfiguration?.showPhoneNumberDialog;
    this.dashboardContext.setContextValue('showPhoneNumberDialog', showPhoneNumberDialog === true);

    const showHints = this.wizardComponent.currentStep.dashboardConfiguration?.showHints;
    this.dashboardContext.setContextValue('showHints', showHints === true);

    this.dashboardContext.setContextValue('smartphoneConnectionEnabled', true);
    this.dashboardContext.setContextValue('useGlobalConnect', false);
    this.dashboardContext.setContextValue('useSms', false);
    this.onDriverCommunicationChange();
  }

  private onDriverCommunicationChange() {
    const driverCommunication = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication);
    // Status erst zurücksetzen, dann im jeweiligen Fall neu berechnen
    this.dashboardContext.setContextValue(TerminalContextConstants.smartphoneConnected, false);

    if (driverCommunication === 'phone-call') {
      this.dashboardContext.setContextValue(TerminalContextConstants.smartphoneConnected, true);
      this.dashboardContext.setContextValue('useGlobalConnect', false);
      this.dashboardContext.setContextValue('useSms', false);

    } else if (driverCommunication === 'sms') {
      this.dashboardContext.setContextValue(TerminalContextConstants.smartphoneConnected, true);
      this.dashboardContext.setContextValue('useGlobalConnect', false);
      this.dashboardContext.setContextValue('useSms', true);

    } else if (driverCommunication === TerminalContextConstants.DRIVER_COMMUNICATION_LOANER) {
      this.dashboardContext.setContextValue('useGlobalConnect', true);
      this.dashboardContext.setContextValue('useSms', false);
      this.dashboardContext.setContextValue(TerminalContextConstants.smartphoneConnected, true);

    } else if (driverCommunication === TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE) {

      const gcCaseUrl = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseUrl);
      const gcCaseId = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseId);

      if (gcCaseId != null && gcCaseUrl != null) {
        this.dashboardContext.setContextValue('useGlobalConnect', true);
        this.dashboardContext.setContextValue('useSms', false);
        this.checkConnection();
        return;
      }

      this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
      const connectionRequest = new MobileConnection();
      connectionRequest.registrationId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
      connectionRequest.carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
      connectionRequest.driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
      connectionRequest.coDriver = this.dashboardContext.getContextValue(TerminalContextConstants.coDriver);
      connectionRequest.supplier = this.dashboardContext.getContextValue(TerminalContextConstants.supplier);
      connectionRequest.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
      connectionRequest.trailerNumberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.trailerNumberPlate);
      connectionRequest.supplier = this.dashboardContext.getContextValue(TerminalContextConstants.supplier);

      return this.appServerAPI.execute(`/terminal/connectMobile`, connectionRequest).toPromise().then((
        response: MobileConnectionResult) => {
        this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, response.caseId);
        this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseUrl, response.caseUrl);
        this.dashboardContext.setContextValue('useGlobalConnect', true);
        this.dashboardContext.setContextValue('useSms', false);
        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
        this.checkConnection();
      }, error => {
        console.log('Error received from connectMobile endpoint', error);
        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
      });
    }
  }

  validatePhoneNumber(phoneNumber: string): boolean {
    if (!this.regexNumbers.test(phoneNumber) || phoneNumber != null && (!phoneNumber.startsWith("+") || phoneNumber.indexOf("+") != phoneNumber.lastIndexOf("+")
      || phoneNumber.replace(" ", "").startsWith("+490") || phoneNumber.replace(" ", "").startsWith("+4949") || phoneNumber.replace(" ", "").startsWith("+490049"))) {
      return false;
    }
    return true;
  }

  checkConnection() {
    const gcCaseId = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseId);

    if (!gcCaseId || this.dashboardContext.getContextValue(TerminalContextConstants.smartphoneConnected) === true) {
      return;
    }

    window.setTimeout(() => {
      this.appServerAPI.execute(`/terminal/registration/notify`, {
        caseId: gcCaseId
      }).subscribe((response: any) => {
        console.log('Registration notify', response);
        if (response !== null && response.caseId !== null && response.caseId === gcCaseId) {
          this.dashboardContext.setContextValue(TerminalContextConstants.smartphoneConnected, true);
          this.wizardComponent.next();
        }
        else {
          this.checkConnection();
        }
      },
        (error) => {
          this.retry = this.retry + 1;
          if (this.retry <= this.maxRetries) {
            console.log('retry ' + this.retry + ' of ' + this.maxRetries);
          } else {
            this.showHttpError();
          }
        });

    }, this.refreshInterval);

  }

  private showHttpError() {
    const matDialog = WizardServiceLocator.injector.get(DialogService);

    matDialog.showInfoDialog(
      'tmc-yard.widgets.registration-terminal.http.error.title',
      'tmc-yard.widgets.registration-terminal.http.error.message'
    ).afterClosed().subscribe(
      () => this.wizardComponent.startProcessFlow('registration-terminal-wizard-configuration')
    );
  }

  public onAlreadyConnected() {
    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.already-connected-dialog.title',
      'tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.already-connected-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.wizardComponent.stopInactivityMonitoring();
        this.dashboardContext.setContextValue(TerminalContextConstants.smartphoneConnected, true);
        this.wizardComponent.next();
      }
    });
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('smartphone connection started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private updateControls() {
    const driverCommunication = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication);
    console.log('phone number', this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber));

    this.nextControl.visible = false;
    this.nextControl.disabled = true;
    this.alreadyConnectedControl.visible = false;
    this.alreadyConnectedControl.disabled = true;

    if (driverCommunication === TerminalContextConstants.DRIVER_COMMUNICATION_LOANER) {
      this.nextControl.visible = true;
      this.nextControl.disabled = false;
    } else if (driverCommunication === 'phone-call' || driverCommunication === 'sms') {
      if (this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber) != null && this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber).length > 0 && this.phoneNumberValid) {
        this.nextControl.visible = true;
        this.nextControl.disabled = false;
      } else if (this.dashboardContext.getContextValue('hidePhoneNumberInput') === true) {
        this.nextControl.visible = true;
        this.nextControl.disabled = false;
      }
    } else if (driverCommunication === TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE) {
      if (this.dashboardContext.getContextValue('showPhoneNumberInputForGlobalConnect') === true) {
        if (this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber) != null && this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber).length > 0 && this.phoneNumberValid) {
          this.alreadyConnectedControl.visible = true;
          this.alreadyConnectedControl.disabled = false;
        }
      } else {
        this.alreadyConnectedControl.visible = true;
        this.alreadyConnectedControl.disabled = false;
      }
    }

  }

  private cancel() {

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const previousControl = new StepControl();
    previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
    previousControl.type = StepControlType.BUTTON_STROKED;
    previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
    previousControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.previous();
    };
    controls.push(previousControl);

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    this.nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
    this.nextControl.type = StepControlType.BUTTON;
    this.nextControl.iconAfterCss = 'fa-thin fa-angle-right';
    this.nextControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();;
      this.wizardComponent.next();
    };
    controls.push(this.nextControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    this.alreadyConnectedControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.button.alreadyconnected';
    this.alreadyConnectedControl.type = StepControlType.BUTTON;
    this.alreadyConnectedControl.iconAfterCss = 'fa-thin fa-angle-right';
    this.alreadyConnectedControl.controlAction = () => this.onAlreadyConnected();
    controls.push(this.alreadyConnectedControl);

    // Calculate right button state
    this.updateControls();

    return controls;
  }
}
